import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { registerSchema, UserRegisterForm } from '../../../validators/auth.schemas'
import Input from '../../../components/Input'
import Button from '../../../components/Button'
import { Container, ContentCenter, Form, Row } from '../../../components/commons'
import { useNavigate } from 'react-router-dom'
import { api } from '../../../services/api'
import { useUserStore } from '../../../store/user'
import { useAuthStore } from '../../../store/auth'
import useToast from '../../../hooks/useToast'
import SelectInput from '../../../components/Input/SelectInput'
import states from '../../../utils/states'
import CheckboxInput from '../../../components/Input/CheckboxInput'
import axios from 'axios'
import { ResponseError } from '../../../validators/utils.interface'
import { masks } from '../../../utils/masks'
import Avatar from '../../../components/Avatar'
import { useConfigStore } from '../../../store/config'

export interface RegisterProps {}

const Register: React.FunctionComponent<RegisterProps> = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = React.useState<boolean>(false)

  const config = useConfigStore((state) => state).config

  const toast = useToast()

  const { setToken } = useAuthStore((state) => state)
  const { setUser } = useUserStore((state) => state)

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<UserRegisterForm>({
    defaultValues: {
      name: '',
      email: '',
      document: '',
      state: '',
      city: '',
      manager: false,
      portariaNomeacao: '',
      vigenciaNomeacao: '',
      password: '',
      confirmPassword: '',
    },
    resolver: yupResolver(registerSchema),
  })

  const handleSubmitRegister = async (formData: UserRegisterForm) => {
    try {
      setLoading(true)

      await api.post('/signup', {
        ...formData,
        document: masks.unmask(formData.document),
        confirmPassword: undefined,
      })

      const { data: response } = await api.post('/login', {
        document: masks.unmask(formData.document),
        password: formData.password,
      })

      setUser(response.data)
      setToken(response.token)

      toast.successToast('Login realizado com sucesso !')
    } catch (error) {
      const typedError = error as ResponseError
      if (axios.isAxiosError(error)) {
        toast.errorToast(typedError?.response?.data?.message)
      } else {
        toast.errorToast('Erro ao efetuar o registro !')
      }
    } finally {
      setLoading(false)
    }
  }

  const state = watch('state')
  const gestor = watch('manager')

  return (
    <Container>
      <ContentCenter>
        <Avatar borderRadius={15} width={150} height={150} source={config?.logo} />
      </ContentCenter>
      <Form onSubmit={handleSubmit(handleSubmitRegister)}>
        <Input
          label='Nome Completo'
          placeholder='Digite seu nome'
          error={errors?.name}
          control={control}
          type='text'
          name='name'
        />
        <Input
          label='CPF'
          placeholder='Digite seu CPF'
          error={errors?.document}
          control={control}
          type='text'
          mask={'cpf'}
          name='document'
        />
        <Row style={{ gap: 15 }}>
          <SelectInput
            label='Estado'
            placeholder='Digite seu estado'
            error={errors?.state}
            control={control}
            options={states.map((state: any) => ({
              label: state.nome,
              value: state.sigla,
            }))}
            name='state'
          />
          <SelectInput
            label='Cidade'
            placeholder='Digite sua cidade'
            error={errors?.city}
            control={control}
            options={
              state
                ? states
                    .find((stateFound) => stateFound.sigla === state)
                    ?.cidades.map((cid) => ({
                      label: cid,
                      value: cid,
                    }))
                : []
            }
            //label='E-mail'
            name='city'
          />
        </Row>
        <Input
          placeholder='Digite seu email'
          error={errors?.email}
          control={control}
          label='E-mail'
          type='email'
          name='email'
        />
        <Input
          placeholder='Digite sua senha'
          error={errors?.password}
          control={control}
          label='Senha'
          type='password'
          name='password'
        />
        <Input
          placeholder='Confirme sua senha'
          error={errors?.confirmPassword}
          control={control}
          label='Confirme sua senha'
          type='password'
          name='confirmPassword'
        />
        <CheckboxInput type='checkbox' name='manager' control={control} label='Sou Gestor' />
        {gestor && (
          <Row style={{ gap: 15 }}>
            <Input
              label='Portaria de Nomeação'
              placeholder='Digite a Portaria de Nomeação'
              error={errors?.portariaNomeacao}
              control={control}
              type='text'
              name='portariaNomeacao'
            />
            <Input
              label='Vigência de Nomeação'
              placeholder='Digite sua Vigência de Nomeação'
              error={errors?.vigenciaNomeacao}
              control={control}
              type='text'
              //label='E-mail'
              name='vigenciaNomeacao'
            />
          </Row>
        )}

        <Button
          label='Cadastrar'
          loading={loading}
          type='submit'
          fullWidth
          variantType='block'
          color='primary'
        />
        <ContentCenter>
          <Button
            onClick={() => navigate('/login')}
            label='Logar-se'
            variantType='label'
            color='primary'
          />
        </ContentCenter>
      </Form>
    </Container>
  )
}

export default Register
